export const FIELD_TYPE_MAP_OF_NAME = {
  TypeIgnore: 1,
  TypeInt: 2,
  TypeString: 3,
  TypeDouble: 4,
  TypeDoubleArray: 5,
  TypeIntArray: 6,
  TypeStringArray: 7,
  TypeBool: 8,
  TypeDate: 9,
};

export const FIELD_TYPE_MAP_OF_VALUE = {
  1: 'TypeIgnore',
  2: 'TypeInt',
  3: 'TypeString',
  4: 'TypeDouble',
  5: 'TypeDoubleArray',
  6: 'TypeIntArray',
  7: 'TypeStringArray',
  8: 'TypeBool',
  9: 'TypeDate',
};

// 新增组件配置请按照英文字母顺序（a-z）排列
export const RULE_TYPE_MAP = {
  Address: {
    name: 'Address',
    fieldType: FIELD_TYPE_MAP_OF_NAME.TypeStringArray,
  },
  Age: {
    name: 'Age',
    fieldType: FIELD_TYPE_MAP_OF_NAME.TypeIntArray,
  },
  Birthday: {
    name: 'Birthday',
    fieldType: FIELD_TYPE_MAP_OF_NAME.TypeDate,
  },
  Company: {
    name: 'Company',
    fieldType: FIELD_TYPE_MAP_OF_NAME.TypeString,
  },
  CustomerStatus: {
    name: 'CustomerStatus',
    fieldType: [FIELD_TYPE_MAP_OF_NAME.TypeIntArray, FIELD_TYPE_MAP_OF_NAME.TypeIntArray],
    fieldList: ['status', 'holder'],
    cgi: '/cl/CuCfg/CuAttrPage',
  },
  CustomerTag: {
    name: 'CustomerTag',
    fieldType: FIELD_TYPE_MAP_OF_NAME.TypeIntArray,
    cgi: '/cl/CuCfg/CuAttrPage',
  },
  Education: {
    name: 'Education',
    fieldType: FIELD_TYPE_MAP_OF_NAME.TypeIntArray,
  },
  Gender: {
    name: 'Gender',
    fieldType: FIELD_TYPE_MAP_OF_NAME.TypeIntArray,
  },
  PageHolder: {
    name: 'PageHolder',
    fieldType: FIELD_TYPE_MAP_OF_NAME.TypeInt,
  },
  PagePV: {
    name: 'PagePV',
    fieldType: FIELD_TYPE_MAP_OF_NAME.TypeInt,
  },
  Placeholder: {
    name: 'Placeholder',
    fieldType: null,
  },
  Post: {
    name: 'Post',
    fieldType: FIELD_TYPE_MAP_OF_NAME.TypeString,
  },
  TextInput: {
    name: 'TextInput',
    fieldType: FIELD_TYPE_MAP_OF_NAME.TypeString,
  },
  Region: {
    name: 'Region',
    fieldType: FIELD_TYPE_MAP_OF_NAME.TypeStringArray,
  },
  IpRegion: {
    name: 'IpRegion',
    fieldType: FIELD_TYPE_MAP_OF_NAME.TypeStringArray,
  },
  OrgSelect: {
    name: 'OrgSelect',
    fieldType: FIELD_TYPE_MAP_OF_NAME.TypeIntArray,
  },
  BusinessSelect: {
    name: 'BusinessSelect',
    fieldType: FIELD_TYPE_MAP_OF_NAME.TypeIntArray,
  },
  RobotSelect: {
    name: 'RobotSelect',
    fieldType: FIELD_TYPE_MAP_OF_NAME.TypeIntArray,
  },
  Remarks: {
    name: 'Remarks',
    fieldType: FIELD_TYPE_MAP_OF_NAME.TypeString,
  },
  SessionChannel: {
    name: 'SessionChannel',
    fieldType: FIELD_TYPE_MAP_OF_NAME.TypeIntArray,
    cgi: '/tp/channelConf/getKfextChannelList',
  },
  StorageTime: {
    name: 'StorageTime',
    fieldType: FIELD_TYPE_MAP_OF_NAME.TypeDate,
  },
  VisitingTime: {
    name: 'VisitingTime',
    fieldType: FIELD_TYPE_MAP_OF_NAME.TypeIntArray,
  },
};
export default {};
